module.exports = __webpack_public_path__ + "img/leftArrow.bd8e3922.svg";